import ArrowRightFromBaseIconPath from "@ingka/ssr-icon/paths/arrow-right-from-base";

export default ArrowRightFromBaseIconPath;
